var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3476_2028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6367 3.25439L19.1914 16.3391C19.3066 16.5387 19.3672 16.765 19.3672 16.9954C19.3672 17.2258 19.3066 17.4521 19.1914 17.6516C19.0762 17.8512 18.9105 18.0168 18.711 18.132C18.5115 18.2472 18.2852 18.3079 18.0548 18.3079H2.94528C2.71489 18.3079 2.48856 18.2472 2.28904 18.132C2.08952 18.0168 1.92384 17.8512 1.80865 17.6516C1.69345 17.4521 1.63281 17.2258 1.63281 16.9954C1.63281 16.765 1.69346 16.5387 1.80865 16.3391L9.3634 3.25439C9.86828 2.37939 11.1309 2.37939 11.6367 3.25439ZM10.5 13.6249C10.268 13.6249 10.0454 13.7171 9.88131 13.8812C9.71722 14.0453 9.62503 14.2678 9.62503 14.4999C9.62503 14.732 9.71722 14.9545 9.88131 15.1186C10.0454 15.2827 10.268 15.3749 10.5 15.3749C10.7321 15.3749 10.9547 15.2827 11.1187 15.1186C11.2828 14.9545 11.375 14.732 11.375 14.4999C11.375 14.2678 11.2828 14.0453 11.1187 13.8812C10.9547 13.7171 10.7321 13.6249 10.5 13.6249ZM10.5 7.49989C10.2857 7.49992 10.0789 7.57861 9.9187 7.72102C9.75855 7.86343 9.65623 8.05968 9.63115 8.27252L9.62503 8.37489V11.8749C9.62528 12.0979 9.71067 12.3124 9.86377 12.4746C10.0169 12.6368 10.2261 12.7344 10.4487 12.7474C10.6714 12.7605 10.8906 12.6881 11.0616 12.5449C11.2327 12.4018 11.3426 12.1987 11.3689 11.9773L11.375 11.8749V8.37489C11.375 8.14283 11.2828 7.92027 11.1187 7.75618C10.9547 7.59208 10.7321 7.49989 10.5 7.49989Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3476_2028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightWarning);
export default __webpack_public_path__ + "static/media/light-warning.7194a94791e2d2945b11b212793e3418.svg";
export { ForwardRef as ReactComponent };